<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage">
            <b-row style="margin-top:100px">
                <b-col>
                    <!-- <p>Select sepecies to find more information about them</p> -->
                </b-col>
            </b-row>                       
            <b-row style="margin-top:30px">
                <b-col align-self="center">
                    <b-tabs
                        active-nav-item-class="font-weight-bold text-uppercase"
                        active-tab-class="font-weight-bold text-success"
                        justified
                    >
                    <b-tab>
                        <template v-slot:title>
                            <font-awesome-icon icon="list-ul" size="2x"></font-awesome-icon> Associated Species
                        </template>
                         <b-row>
                            <b-col>
                                <Plotly :data="speciesGraphData" :layout="spLayout" :display-mode-bar="false" :autoResize="true"></Plotly>
                            </b-col>                            
                        </b-row>
                        <b-row>
                            <b-col>
                                <div id="boxBg">
                                    Over one-third of the species of human gut microbes were significantly and consistently altered after transplanted to mice.
The box plot shows the relative abundances changes (log2-transformed; Log2FC) at species level in the 1,713 human-mouse pairs of samples we have collected. Boxes were colored according to the number of samples (sample count) in which a genus was found; sample counts in this plot range from 26 to 1,697. If the median Log2FC value of a species is higher or lower than 1, it is considered to be significantly altered after FMT.
                                </div>
                            </b-col>
                        </b-row>
                        <b-row style="margin-top:10px;margin-bottom:10px">
                            <b-col style="align:left">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="speFilter"
                                    type="search"
                                    id="filterSpecies"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!speFilter" @click="speFilter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-row style="margin-top:20px">
                        <b-table
                                responsive
                                show-empty
                                :bordered="true"
                                :busy.sync="isSpeciesBusy"
                                :striped="false"
                                :outlined="true"
                                :items="spe_tab_data"
                                :fields="spe_tab_fields"
                                :current-page="speCurrentPage"
                                :per-page="spePerPage"
                                :filter="speFilter"
                            >
                            <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                                    </template>
                                  <template v-slot:cell(show_details)="row">
                                        <b-button size="sm" @click="toggleDetails(row,1)">
                                                {{ row.detailsShowing ? '-' : '+'}}
                                        </b-button>
                                  </template>
                                  <template v-slot:cell(index)="data">
                                      <span v-if="speCurrentPage>1">
                                          {{ data.index + 1 +(speCurrentPage*spePerPage)-spePerPage}}
                                      </span>
                                      <span v-else>
                                          {{ data.index + 1 }}
                                      </span>    
                                  </template>
                                  <template v-slot:cell(name)="data">
                                    {{data.item.name}} <router-link :to="{ path: '/viewpair/sp/'+data.item.name}" target="_blank">
                                    <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link> 
                                  </template>
                                  <template v-slot:row-details="row">
                                      <b-table
                                            sticky-header
                                            responsive
                                            show-empty
                                            :bordered="true"
                                            :busy.sync="row.item.loading"
                                            :striped="false"
                                            :outlined="true"
                                            :items="row.item.subarray"
                                            :fields="sub_tab_fields"
                                      >
                                      <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                                    </template>
                                      <template v-slot:cell(index)="data">
                                            {{ data.index + 1 }}
                                      </template>
                                      <template v-slot:cell(humanRun) ="row">
                                            <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.humanRun.trim()" target="_blank">{{row.item.humanRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                                      </template>
                                      <template v-slot:cell(mouseRun) ="row">
                                            <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.mouseRun.trim()" target="_blank">{{row.item.mouseRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                                      </template>
                                      <template v-slot:cell(viewpair)="data">
                                        <router-link :to="{ path: '/viewpair/p/'+data.item.humanRun.trim()+'/'+data.item.mouseRun.trim()}" target="_blank" >
                                            <b-button size="sm" variant="primary">View</b-button>
                                        </router-link> 
                                    </template>
                                      </b-table>
                                  </template>
                        </b-table>
                        </b-row>
                        <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="speCurrentPage"
                                :total-rows="speTotalRows"
                                :per-page="spePerPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="spePerPage" :options="spePageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <font-awesome-icon icon="list-ul" size="2x"></font-awesome-icon> Associated Genus
                        </template>
                        <b-row>
                                <b-col>
                                    <Plotly :data="genusGraphData" :layout="genLayout" :display-mode-bar="false" :autoResize="true"></Plotly>
                                </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div id="boxBg">
                                Over one-third of the genera of human gut microbes were significantly and consistently altered after transplanted to germ-free mice.
The box plot shows the relative abundances changes (log2-transformed; Log2FC) at genus level in the 1,713 human-mouse pairs we have collected (see Materials and Methods for details). Boxes were colored according to the number of samples (sample count) in which a genus was found; sample counts in this plot range from 81 to 1,713. If the median Log2FC value of a genus is higher or lower than 1, it is considered to be significantly altered after FMT.
                                </div>
                            </b-col>
                        </b-row>
                        <b-row style="margin-top:10px;margin-bottom:10px">
                            <b-col style="align:left">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="genFilter"
                                    type="search"
                                    id="filterSpecies"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!genFilter" @click="genFilter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-row style="margin-top:20px">
                        <b-table
                                responsive
                                show-empty
                                :bordered="true"
                                :busy.sync="isGenBusy"
                                :striped="false"
                                :outlined="true"
                                :items="gen_tab_data"
                                :fields="gen_tab_fields"
                                :current-page="gen_currentPage"
                                :per-page="gen_perPage"
                                :filter="genFilter"
                            >
                            <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                                    </template>
                            <template v-slot:cell(show_details)="row">
                                <b-button size="sm" @click="toggleDetails(row,2)">
                                    {{ row.detailsShowing ? '-' : '+'}}
                                </b-button>
                            </template>
                            <template v-slot:cell(index)="data">
                                <span v-if="gen_currentPage>1">{{ data.index + 1 +(gen_currentPage*gen_perPage)-gen_perPage}}</span>
                                <span v-else>{{ data.index + 1 }}</span>
                            </template>
                            <template v-slot:cell(name)="data">
                                    {{data.item.name}} <router-link :to="{ path: '/viewpair/gen/'+data.item.name}" target="_blank">
                                    <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link> 
                            </template>
                            <template v-slot:row-details="row">                                
                                <b-table
                                    sticky-header
                                    responsive
                                    show-empty
                                    :bordered="true"
                                    :busy.sync="row.item.loading"
                                    :striped="false"
                                    :outlined="true"
                                    :items="row.item.subarray"
                                    :fields="sub_tab_fields"        
                                >
                                <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                    <template v-slot:cell(humanRun) ="row">
                                        <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.humanRun.trim()" target="_blank">{{row.item.humanRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                                    </template>
                                    <template v-slot:cell(mouseRun) ="row">
                                        <a v-bind:href="'https://trace.ncbi.nlm.nih.gov/Traces/sra/?run=' + row.item.mouseRun.trim()" target="_blank">{{row.item.mouseRun.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></a>
                                    </template>
                                    <template v-slot:cell(viewpair)="data">
                                        <router-link :to="{ path: '/viewpair/p/'+data.item.humanRun.trim()+'/'+data.item.mouseRun.trim()}" target="_blank" >
                                            <b-button size="sm" variant="primary">View</b-button>
                                        </router-link> 
                                    </template>
                                </b-table>
                            </template>
                        </b-table>
                        </b-row>
                        <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="gen_currentPage"
                                :total-rows="gen_totalRows"
                                :per-page="gen_perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="gen_perPage" :options="genPageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
            <b-row>
                <!-- <vue-scrolling-table>
                </vue-scrolling-table> -->
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return{
            server_add:this.$hostname,
            showPage:false,
            loadCounter:0,
            bacSpOptions:[],
            speciesGraphData:[],
            spLayout:{
                title: "Log2FC at Species level",
                xaxis:{
                    automargin: true
                }
            },
            genusGraphData:[],
            genLayout:{
                title: "Log2FC at Genus level",
                xaxis:{
                    automargin: true
                }
            },
            bacSp:{
                value:'',
                text:''
            },
            isGenBusy:true,
            gen_tab_data:[],
            gen_tab_fields:[
                    { key:'show_details',label: ''},
                    {key:'index',label:'S.No'},
                    { key:'name',label:'Genus',sortable:true },
                    { key: 'totalPairs', label: 'Total pairs', sortable: true },
            ],
            gen_totalRows: 1,
            gen_currentPage: 1,
            gen_perPage: 15,
            genPageOptions: [5, 10, 15,25],
            genFilter: null,
            isSpeciesBusy:true,
            spe_tab_data:[],
            spe_tab_fields:[
                    { key:'show_details',label: ''},
                    { key:'index',label:'S.No'},
                    { key:'name',label:'Species',sortable:true },
                    { key: 'totalPairs', label: 'Total pairs', sortable: true },
            ],
            speTotalRows: 1,
            speCurrentPage: 1,
            spePerPage: 15,
            spePageOptions: [5, 10, 15,25],
            speFilter: null, 
            subSpecBusy:true,
            subGenusBusy:true,
            sub_tab_fields:[
                    {key:'index',label:''},
                    {key:'humanRun',label:'Human Experiment ID'},
                    {key:'mouseRun',label:'Mouse Experiment ID'},
                    {key:'humanRelativeAbundance',label:'Rel Abundance in Human'},
                    {key:'mouseRelativeAbundance',label:'Rel Abundance in Mouse'},
                    {key:'reducedPct',label:'Reduction (Log2FC)',sortable:true},
                    { key:'viewpair',label:''},                    
            ]
        }
    },
    mounted() {        
        this.loadBoxPlotSpGraph()
        this.loadGenusPairs()
        this.loadSpeciesPairs()
    },
    methods: {
        loadGenusPairs(){
            axios.post(this.server_add+'query/getGenusHmPairs',
            {
            }).then(retDat => {
                if(retDat.status === 200){
                    this.gen_tab_data = retDat.data
                    this.gen_totalRows = retDat.data.length
                    this.isGenBusy = false
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadSpeciesPairs(){
            axios.post(this.server_add+'query/getSpeciesHmPairs',
            {
            }).then(retDat => {
                if(retDat.status === 200){
                    this.spe_tab_data = retDat.data
                    this.speTotalRows = retDat.data.length
                    this.isSpeciesBusy = false
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },
        toggleDetails(item,typ) {
            item.toggleDetails()
            var spc_url = this.server_add+'query/getSpeciesHmPairsSub?species='+item.item.name
            var gen_url = this.server_add+'query/getGenusHmPairsSub?genus='+item.item.name
            var url = spc_url
            if(typ === 2){
                url = gen_url
            }
            if (item.item.subarray) { // if details already exists, show the details
                // this.$set(item.item, '_showDetails', true)
            }else{
                // console.log(typ,item)
                fetch(`${url}`)
                .then(response => response.json())
                .then(json => {
                    item.item.subarray = json
                    item.item.loading = false;
                    item.item.subDisplayed = true
                })
            }
        },
        loadBoxPlotSpGraph(){
            axios.post(this.server_add+'query/speciesRelAbundanceChange',
            {
            }).then(retDat => {
                if(retDat.status === 200){
                    var sp = retDat.data.species
                    var genus = retDat.data.genus
                    for(let i=0;i<sp.length;i++){                                  
                        var trace = {
                            y:sp[i].value,
                            type:'box',
                            name:sp[i].key
                        }
                        this.speciesGraphData.push(trace)
                    }
                    for(let i=0;i<genus.length;i++){                                  
                        var trac = {
                            y:genus[i].value,
                            type:'box',
                            name:genus[i].key
                        }
                        this.genusGraphData.push(trac)
                    }
                    this.loadCounter++
                }
            }).catch(err => {
                console.log(err)
            })
        },      
    },
    watch: {
        loadCounter: function(newValue, oldValue) {
            this.showPage   = newValue>=3
        }
    },
}

</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}
</style>